import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useCommandPalette } from 'contextProviders/CommandPaletteProvider';

const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
const shortcutLabel = isMac ? '\u2318K' : 'Ctrl+K';

const SearchTrigger: React.FC = () => {
  const { open } = useCommandPalette();

  return (
    <Tooltip title={`Search (${shortcutLabel})`} arrow placement="bottom">
      <IconButton
        data-tour="nav-search"
        onClick={open}
        aria-label={`Open search (${shortcutLabel})`}
        size="small"
        sx={{
          ml: 'auto',
          mr: 1.5,
          color: 'text.secondary',
          '&:hover': {
            color: 'text.primary',
          },
        }}
      >
        <SearchIcon sx={{ fontSize: 20 }} />
      </IconButton>
    </Tooltip>
  );
};

export default SearchTrigger;
